        function openDropdown(dropdown) {
            if (!dropdown) return;

            const button = dropdown.querySelector('[data-custom-size-dropdown-button]');
            const selectedItem = dropdown.querySelector('[data-custom-size-dropdown-item].is-selected:not(.is-unavailable)');
            const firstAvailableItem = dropdown.querySelector('[data-custom-size-dropdown-item]:not(.is-unavailable)');

            closeAllDropdowns(dropdown);
            dropdown.classList.add('is-open');

            if (button) {
                button.setAttribute('aria-expanded', 'true');
            }

            requestAnimationFrame(() => {
                if (selectedItem) {
                selectedItem.focus({ preventScroll: true });
                } else if (firstAvailableItem) {
                firstAvailableItem.focus({ preventScroll: true });
                }
            });
        }
        
        function toggleDropdown(dropdown) {

            console.log('=== toggleDropdown::64');

            if (!dropdown) return;

            if (dropdown.classList.contains('is-open')) {
                closeDropdown(dropdown);
            } else {
                openDropdown(dropdown);
            }
        }
        function selectCustomDropdownItem(item) {
            if (!item || item.classList.contains('is-unavailable')) return;

            const dropdown = item.closest('[data-custom-size-dropdown]');
            if (!dropdown) return;

            const select = dropdown.querySelector('[data-native-size-select]');
            const current = dropdown.querySelector('[data-custom-size-dropdown-current]');
            const value = item.dataset.value;

            if (!select || value == null) return;

            select.value = value;

            dropdown.querySelectorAll('[data-custom-size-dropdown-item]').forEach((dropdownItem) => {
                const isSelected = dropdownItem === item;

                dropdownItem.classList.toggle('is-selected', isSelected);
                dropdownItem.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            });

            if (current) {
                current.textContent = getCleanItemText(item);
            }

            closeDropdown(dropdown);
            triggerNativeSelectChange(select);
        }

        function getCleanItemText(item) {
            const textElement = item.querySelector('.variant-option__custom-dropdown-item-text');

            if (textElement) {
                return textElement.textContent.trim();
            }

            return item.textContent.replace('✓', '').replace('Out of Stock', '').trim();
        }

        function syncDropdownFromNativeSelect(select) {
            if (!select) return;

            const dropdown = select.closest('[data-custom-size-dropdown]');
            if (!dropdown) return;

            const current = dropdown.querySelector('[data-custom-size-dropdown-current]');
            const items = dropdown.querySelectorAll('[data-custom-size-dropdown-item]');
            const selectedValue = select.value;

            items.forEach((item) => {
                const isSelected = item.dataset.value === selectedValue;

                item.classList.toggle('is-selected', isSelected);
                item.setAttribute('aria-selected', isSelected ? 'true' : 'false');

                if (isSelected && current) {
                current.textContent = getCleanItemText(item);
                }
            });
        }

        function closeAllDropdowns(exceptDropdown = null) {
            document.querySelectorAll('[data-custom-size-dropdown].is-open').forEach((dropdown) => {
                if (dropdown !== exceptDropdown) {
                closeDropdown(dropdown);
                }
            });
        }

        function closeDropdown(dropdown) {
            if (!dropdown) return;

            const button = dropdown.querySelector('[data-custom-size-dropdown-button]');

            dropdown.classList.remove('is-open');

            if (button) {
                button.setAttribute('aria-expanded', 'false');
            }
        }

        function triggerNativeSelectChange(select) {
            if (!select) return;

            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }